import type { ReactElement } from 'react';
import { memo } from 'react';

import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

import { MenuItemThumbnail } from './MenuItemThumbnail';

const MenuItemSkeletonRaw = (): ReactElement => (
    <Stack
        direction="row"
        sx={{
            flexGrow: 1,
        }}
    >
        <MenuItemThumbnail isLoading />
        <Box
            sx={{
                p: 3,
                display: 'flex',
                flexGrow: 1,
            }}
        >
            <Skeleton
                variant="rectangular"
                height={30}
                width="100%"
            />
        </Box>
    </Stack>
);

MenuItemSkeletonRaw.displayName = 'MenuItemSkeleton';

const MenuItemSkeleton = memo(MenuItemSkeletonRaw);

export default MenuItemSkeleton;
